import * as React from 'react'

import {
  Box,
  type Colors,
  Icon,
  Link,
  Text,
  Touchable,
} from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'

import './index.styles.css'
// If a link is provided we also need the linkText and vice versa
type AllOrNone<T> = Required<T> | Partial<Record<keyof T, undefined>>

export interface MainProps extends LinkProps {
  background?: Colors
  icon?: React.ComponentProps<typeof Icon.Large>['icon']
  title?: string
  message: string | React.ReactNode
  onClose?: () => void
  trackingProperties?: Record<string, unknown> | undefined
  iconColor?: Colors
}

interface LinkProps {
  link?: HelpCenterUrl
  linkText?: string
}
interface RouterLinkProps {
  routerTo?: string
  routerToText?: string
}
type Props = MainProps & AllOrNone<LinkProps> & AllOrNone<RouterLinkProps>

const FactorialTip = ({
  background = 'viridian100',
  icon,
  title,
  message,
  link,
  linkText,
  onClose,
  trackingProperties,
  iconColor = 'viridian1000',
  routerTo,
  routerToText,
}: React.PropsWithChildren<Props>) => {
  const trackingPropertiesWithDestination = trackingProperties
    ? { ...trackingProperties, link: link }
    : undefined

  return (
    <Box
      background={background}
      paddingLeft="s24"
      paddingBottom="s24"
      paddingRight="s16"
      paddingTop="s16"
      borderRadius={{ all: 'abs004' }}
      flexDirection="row"
      justifyContent="spaceBetween"
    >
      <Box>
        {icon && (
          <Box paddingY="s8">
            <Icon.Large icon={icon} color={iconColor} />
          </Box>
        )}
        <Box gap="s8" paddingTop="s8">
          {title && <Text.Normal weight="medium">{title}</Text.Normal>}
          <Text.Normal size="200">{message}</Text.Normal>
        </Box>
        {link && linkText && (
          <Box paddingTop="s16" className={'FactorialTip_linkContainer'}>
            <HelpCenterLink name={link} trackingProperties={trackingPropertiesWithDestination}>
              <Text.Normal weight="medium">{linkText}</Text.Normal>
            </HelpCenterLink>
          </Box>
        )}
        {routerTo && routerToText && (
          <Box paddingTop="s16" className={'FactorialTip_linkContainer'}>
            <Link.Router to={routerTo}>
              <Text.Normal weight="medium">{routerToText}</Text.Normal>
            </Link.Router>
          </Box>
        )}
      </Box>
      {onClose && (
        <Touchable onClick={onClose}>
          <Icon.Small icon="close" color="grey1000" />
        </Touchable>
      )}
    </Box>
  )
}

export default FactorialTip
